// extracted by mini-css-extract-plugin
export default {"container":"file-input_container__GGUl0","content":"file-input_content__dIoN4","closeIcon":"file-input_closeIcon__8XDjV"};